export enum TelematicsCargoFilter {
  ALL = 'all',
  LTL = 'ltl',
  FTL = 'ftl',
}
